import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  const [index, setIndex] = useState(0);
  const active = testimonials[index];
  const go = (dir: number) => setIndex(i => (i + dir + testimonials.length) % testimonials.length);
  return <section className="px-6 py-28 sm:px-10 sm:py-40" data-id="element-136" data-mp="1d3xn6slhev63">
      <div className="mx-auto max-w-[92rem]" data-id="element-137" data-mp="1i1z5vcezwsh1">
        <Reveal data-id="element-138" data-mp="1hyux01ql58k1">
          <div className="flex items-end justify-between gap-6" data-id="element-139" data-mp="1416bcrop1xdx">
            <p className="eyebrow text-mocha" data-id="element-140" data-mp="142zfo0bu45ir">In their words</p>
            <div className="flex gap-2" data-id="element-141" data-mp="182001n9yng7v">
              <button type="button" aria-label="Previous testimonial" onClick={() => go(-1)} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-charcoal/15 text-charcoal/70 transition-all duration-500 hover:border-charcoal/50 hover:text-charcoal" data-id="element-142" data-mp="184uhr71lamxl">
                <ArrowLeftIcon className="h-4 w-4" strokeWidth={1.4} data-id="element-143" data-mp="2q1g68jrlkoyo" />
              </button>
              <button type="button" aria-label="Next testimonial" onClick={() => go(1)} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-charcoal/15 text-charcoal/70 transition-all duration-500 hover:border-charcoal/50 hover:text-charcoal" data-id="element-144" data-mp="34qcdwfpqrzyr">
                <ArrowRightIcon className="h-4 w-4" strokeWidth={1.4} data-id="element-145" data-mp="2m0wbtnyerzg8" />
              </button>
            </div>
          </div>
        </Reveal>

        <div className="mt-12 min-h-[22rem] sm:min-h-[20rem]" data-id="element-146" data-mp="2h0rslq648qmb">
          <AnimatePresence mode="wait" data-id="element-147" data-mp="1af1s180shxs">
            <motion.figure key={active.name} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -12
          }} transition={{
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1]
          }} className="grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-148" data-mp="19cb9uem0hie">
              <div className="lg:col-span-3" data-id="element-149" data-mp="8foiryeedzmh">
                {active.avatar && <img src={active.avatar} alt={active.name} className="h-28 w-28 rounded-full object-cover grayscale sm:h-40 sm:w-40" data-id="element-150" data-mp="davi6u0mwi5l" />}
              </div>
              <div className="lg:col-span-9" data-id="element-151" data-mp="3lryshluscfnh">
                <blockquote className="font-serif text-[1.75rem] font-light italic leading-[1.28] tracking-[-0.01em] text-charcoal sm:text-[2.5rem]" data-id="element-152" data-mp="3lqnnjiplt1us">
                  “{active.quote}”
                </blockquote>
                <figcaption className="mt-10 border-t border-charcoal/12 pt-5" data-id="element-153" data-mp="2y373t4gemffg">
                  <p className="text-sm font-medium text-charcoal" data-id="element-154" data-mp="2y1330vdsxwje">{active.name}</p>
                  <p className="mt-1 text-sm text-charcoal/55" data-id="element-155" data-mp="330pfv3ppxaro">{active.role}</p>
                </figcaption>
              </div>
            </motion.figure>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}